import { Component } from '@angular/core'
import { SafePipe } from '@app/shared/pipe/safe.pipe'
import { EnvService } from '@envs/env-service'
import { environment } from '@envs/environment'
import { AuthService } from '@core/service/auth.service'
import { NavigationService } from '@app/core/service/navigation.service'

@Component({
  selector: 'app-create-folder',
  templateUrl: './create-folder.component.html',
  styleUrls: ['./create-folder.component.scss'],
  providers: [SafePipe],
})
export class CreateFolderComponent {
  constructor(
    private envService: EnvService,
    private authService: AuthService,
    private navigationService: NavigationService
  ) {
    this.navigationService.subscribeToNavigationMessages()
  }

  public get baseJsUrl(): string {
    return `${this.envService.baseJsUrl}/create-folder?host=${environment.baseHost}&childCompany=${this.authService.loggedInUser?.company.id}`
  }
}
